import { MEAL_PATTERN_SLOTS, MEAL_PATTERN_STATUSES } from '@steado/admin-contract/meal-patterns';
import { z } from 'zod';

/**
 * The slot, the status filter and the open pattern live in the URL, so "the
 * drafts waiting on a dinner shape" is a link somebody can paste into a
 * review thread.
 *
 * `history` is off by default: the list is a grammar, and opening on retired
 * drafts would answer a question nobody asked.
 */
export const mealPatternsSearchSchema = z.object({
  slot: z.enum(MEAL_PATTERN_SLOTS).optional().catch(undefined),
  status: z.enum(MEAL_PATTERN_STATUSES).optional().catch(undefined),
  history: z.coerce.boolean().optional().catch(undefined),
  /**
   * Which drawer is open, in one of three forms: `new`, a version's uuid, or
   * `seed:<name>` for one of the shapes the API ships with, which has no
   * database row to have an id.
   *
   * **Not `z.string().uuid()`.** It was, and `.catch(undefined)` then swallowed
   * `new` silently — the New pattern button set the parameter, the route
   * validator dropped it, and the button did nothing at all. Nothing failed
   * loudly, because a `catch` is exactly a promise not to.
   */
  pattern: z
    .string()
    .min(1)
    .max(120)
    .regex(/^(new|seed:[a-z0-9-]+|[0-9a-fA-F-]{36})$/, 'new, seed:<name>, or a version id.')
    .optional()
    .catch(undefined),
});

export type MealPatternsSearch = z.infer<typeof mealPatternsSearchSchema>;

/** The prefix a seeded shape's drawer target carries, since it has no id. */
export const SEEDED_TARGET_PREFIX = 'seed:';

export function seededTarget(slug: string): string {
  return `${SEEDED_TARGET_PREFIX}${slug}`;
}
